import type { ReactNode } from 'react';
import { Alert, AlertTitle } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

/**
 * "O PIN fica na aba Gerais" — o mesmo aviso, do mesmo jeito, em todo modo.
 *
 * Cada aba dizia isso à sua maneira: o totem e o tablet com uma linha solta de
 * texto cinza, o totem de checkout com uma caixa de alerta, e a seção da
 * impressora com outra caixa e outro texto. Três formas de dizer a mesma coisa
 * na mesma tela de configuração.
 *
 * `comoAbrir` acrescenta o caminho no aparelho — útil nas seções que dependem
 * de alguém ir até o equipamento (impressora do totem, mesa do tablet).
 *
 * `intro` é a frase que amarra o aviso ao assunto da seção. Sem ela o alerta
 * emenda um título sobre impressora num texto sobre PIN, e quem lê não entende
 * o que uma coisa tem a ver com a outra.
 */
export function AvisoPinDispositivo({
  comoAbrir = false,
  titulo,
  intro,
}: {
  comoAbrir?: boolean;
  titulo?: string;
  intro?: ReactNode;
}): JSX.Element {
  return (
    <Alert severity="info" icon={<LockIcon />}>
      {titulo && <AlertTitle>{titulo}</AlertTitle>}
      {intro && <>{intro} </>}
      O <strong>PIN do dispositivo</strong> é o mesmo para todos os aparelhos da loja e fica na aba{' '}
      <strong>Gerais</strong>.
      {comoAbrir && (
        <>
          {' '}
          No aparelho, toque em <strong>Sobre</strong> (canto inferior esquerdo) →{' '}
          <strong>Configurações do aparelho</strong> e informe o PIN.
        </>
      )}
    </Alert>
  );
}
